<template>
  <div class="mobileViewStyle user-detail">
    <!-- 系统管理-用户详情（企业微信手机端，仅查看） -->
    <div class="detail-body">
      <list-card :label="detail.employeeName || '用户信息'">
        <template #desc>
          <span class="status-tag" :class="Number(detail.status) === 1 ? 'on' : 'off'">
            {{ Number(detail.status) === 1 ? "正常" : "禁用" }}
          </span>
        </template>
        <data-column label="用户名称">{{ detail.employeeName || "—" }}</data-column>
        <data-column label="联系方式">{{ detail.employeePhone || "—" }}</data-column>
        <data-column label="邮件地址">{{ detail.emailAddress || "—" }}</data-column>
        <!-- 详情接口返回主部门 departName；departList 仅列表接口组装，这里做兜底 -->
        <data-column label="所属部门">{{ departNames || detail.mainDepartName || "—" }}</data-column>
        <data-column label="岗位角色">{{ roleNames || "—" }}</data-column>
        <data-column label="用户状态">{{ Number(detail.status) === 1 ? "正常" : "禁用" }}</data-column>
        <data-column label="最近登录时间">{{ detail.lastLogin || "—" }}</data-column>
        <data-column label="最近登录ip">{{ detail.lastIpAddress || "—" }}</data-column>
      </list-card>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import employeeApi from "@/api/normal/sys/employeeApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "UserDetailQW",
  components: {
    DataColumn, ListCard
  },
  data() {
    return {
      detail: {},
    };
  },
  computed: {
    departNames() {
      return (this.detail.departList || []).map(d => d.departName).filter(name => name).join("、");
    },
    roleNames() {
      return (this.detail.roleList || []).map(r => r.roleName).filter(name => name).join("、");
    },
  },
  created() {
    if (this.route.query.id) {
      employeeApi.findById(this.route.query.id).then(data => this.detail = data || {});
    }
  },
};
</script>

<style lang="scss" scoped>
.user-detail{
  height: 100%;
  overflow: auto;
  .detail-body{
    padding: 10px;
  }
  .status-tag{
    padding: 2px 8px;
    border-radius: 4px;
    font-size: var(--yq-font-size-mini-mobile);
    &.on{
      color: var(--el-color-success);
      background: var(--el-color-success-light-9);
    }
    &.off{
      color: var(--el-color-info);
      background: var(--el-fill-color-light);
    }
  }
}
</style>
